import React, { Component } from "react";
import { Button, Form, Modal, Table } from "react-bootstrap";
import { Link } from "react-router-dom";
import { utcToLocal } from "../../utils/dateConvert";

class UserTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      roleModalUser: null,
      selectedRole: "User",
      statusModalUser: null,
    };
  }

  renderSortHeader = (label, sortKey) => {
    const { onSort, sortDirection, sortKey: activeSortKey } = this.props;
    const active = activeSortKey === sortKey;
    const iconClass = active && sortDirection === "desc"
      ? "fa fa-sort-down"
      : active
        ? "fa fa-sort-up"
        : "fa fa-sort";

    return (
      <button
        className={`user-sort-button ${active ? "active" : ""}`}
        onClick={() => onSort(sortKey)}
        type="button"
      >
        {label}
        <i className={iconClass}></i>
      </button>
    );
  };

  renderStatus = (status) => {
    const statusText = status || "-";
    const statusClass = statusText.toString().toLowerCase().replace(/\s+/g, "-");

    return (
      <span className={`user-status user-status-${statusClass}`}>
        {statusText}
      </span>
    );
  };

  renderRole = (role) => {
    const roleText = role || "User";
    const labels = {
      CommunityManager: "Community Manager",
      "Community Manager": "Community Manager",
      VTDemo: "VtDemo",
      VtDemo: "VtDemo",
      SystemAdmin: "SystemAdmin",
      User: "User",
    };
    const normalisedRole = roleText.toString().toLowerCase().replace(/\s+/g, "");
    const classMap = {
      systemadmin: "systemadmin",
      communitymanager: "communitymanager",
      user: "user",
      vtdemo: "vtdemo",
    };

    return (
      <span className={`vt-role-badge vt-role-badge-${classMap[normalisedRole] || "default"}`}>
        {labels[roleText] || roleText}
      </span>
    );
  };

  getAccessRoleValue = (role) => {
    const normalizedRole = (role || "").toString().toLowerCase().replace(/\s+/g, "");
    return normalizedRole === "communitymanager" ? "CommunityManager" : "User";
  };

  openRoleModal = (user) => {
    this.setState({
      roleModalUser: user,
      selectedRole: this.getAccessRoleValue(user.userType),
    });
  };

  closeRoleModal = () => {
    this.setState({
      roleModalUser: null,
      selectedRole: "User",
    });
  };

  saveRole = () => {
    const { onRoleChange } = this.props;
    const { roleModalUser, selectedRole } = this.state;
    if (roleModalUser && onRoleChange) {
      onRoleChange(roleModalUser, selectedRole);
    }
    this.closeRoleModal();
  };

  openStatusModal = (user) => {
    this.setState({ statusModalUser: user });
  };

  closeStatusModal = () => {
    this.setState({ statusModalUser: null });
  };

  confirmStatusToggle = () => {
    const { onStatusToggle } = this.props;
    const { statusModalUser } = this.state;
    if (statusModalUser && onStatusToggle) {
      onStatusToggle(statusModalUser);
    }
    this.closeStatusModal();
  };

  isDisabledUser = (user) => {
    const statusText = (user.status || "").toString().toLowerCase();
    return statusText === "disabled" || statusText === "disable";
  };

  render() {
    const { UserList } = this.props;
    const { roleModalUser, selectedRole, statusModalUser } = this.state;
    const normalizedRole = (localStorage.getItem("role") || "")
      .toString()
      .trim()
      .toLowerCase()
      .replace(/\s+/g, "");
    const isSystemAdmin = normalizedRole === "systemadmin";
    const canManageAccess = normalizedRole === "communitymanager" || normalizedRole === "vtdemo";

    const statusAction = statusModalUser && this.isDisabledUser(statusModalUser) ? "enable" : "disable";

    return (
      <React.Fragment>
      <Table className="user-table" responsive>
        <thead>
          <tr>
            <th>{this.renderSortHeader("Name", "userName")}</th>
            <th>{this.renderSortHeader("Email", "email")}</th>
            <th>{this.renderSortHeader("Customer", "customerName")}</th>
            <th>{this.renderSortHeader("User Type", "userType")}</th>
            <th>{this.renderSortHeader("Time Zone", "timeZoneCity")}</th>
            <th>{this.renderSortHeader("Last Login", "lastLogin")}</th>
            <th>{this.renderSortHeader("Last IP", "clientIp")}</th>
            <th>{this.renderSortHeader("Status", "status")}</th>
            {isSystemAdmin && <th>Private</th>}
            <th>{this.renderSortHeader("Updated", "dbUpdated")}</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {UserList.length === 0 && (
            <tr>
              <td className="user-empty" colSpan={isSystemAdmin ? "11" : "10"}>
                No users match your search.
              </td>
            </tr>
          )}
          {UserList.map((user, index) => {
            const isDisabled = this.isDisabledUser(user);

            return (
            <tr className={isDisabled ? "user-row-disabled" : ""} key={user.id || index}>
              <td><strong>{user.userName || "-"}</strong></td>
              <td>{user.email || "-"}</td>
              <td>
                {isSystemAdmin ? (
                  <a
                    className="user-customer-link"
                    onClick={() =>
                      localStorage.setItem(
                        "customer",
                        JSON.stringify({
                          customerId: user.customerId,
                          customerName: user.customerName,
                        })
                      )
                    }
                    href={`/users?customerId=${user.customerId}&customerName=${user.customerName}`}
                  >
                    {user.customerName || "-"}
                  </a>
                ) : (
                  user.customerName || "-"
                )}
              </td>
              <td>{this.renderRole(user.userType)}</td>
              <td>{user.timeZoneCity || "-"}</td>
              <td>{user.lastLogin ? user.lastLogin.slice(0, -4) : "-"}</td>
              <td>{user.clientIp || "-"}</td>
              <td>{this.renderStatus(user.status)}</td>
              {isSystemAdmin && (
                <td>
                  {user.isPrivate ? <span className="user-private-pill">Private</span> : "-"}
                </td>
              )}
              <td>{user.dbUpdated ? utcToLocal(user.dbUpdated) : "-"}</td>
              <td className="user-actions">
                {isSystemAdmin && (
                  <React.Fragment>
                    <Link to={`/editUser/${user.id}`}>Edit</Link>
                    <Link to={`/deleteUser/${user.id}`}>Delete</Link>
                  </React.Fragment>
                )}
                {canManageAccess && (
                  <React.Fragment>
                    <button
                      className="user-role-action"
                      onClick={() => this.openRoleModal(user)}
                      type="button"
                    >
                      Role
                    </button>
                    <button
                      className={isDisabled ? "user-access-enable" : "user-access-disable"}
                      onClick={() => this.openStatusModal(user)}
                      type="button"
                    >
                      {isDisabled ? "Enable" : "Disable"}
                    </button>
                  </React.Fragment>
                )}
              </td>
            </tr>
            );
          })}
        </tbody>
      </Table>
      <Modal
        className="user-access-modal"
        centered
        show={!!roleModalUser}
        onHide={this.closeRoleModal}
      >
        <Modal.Header closeButton>
          <Modal.Title>Change User Role</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="user-access-modal-summary">
            <strong>User:</strong>
            <span>{roleModalUser ? roleModalUser.userName : ""}</span>
            <span>{roleModalUser ? roleModalUser.email : ""}</span>
          </div>
          <div className="user-access-modal-current">
            <strong>Current Role:</strong>
            {roleModalUser && this.renderRole(roleModalUser.userType)}
          </div>
          <Form.Group controlId="changeUserRole">
            <Form.Label>Select New Role:</Form.Label>
            <Form.Control
              as="select"
              onChange={(event) => this.setState({ selectedRole: event.target.value })}
              value={selectedRole}
            >
              <option value="User">User</option>
              <option value="CommunityManager">Community Manager</option>
            </Form.Control>
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="danger" onClick={this.closeRoleModal}>
            Cancel
          </Button>
          <Button variant="success" onClick={this.saveRole}>
            Save
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal
        className="user-access-modal"
        centered
        show={!!statusModalUser}
        onHide={this.closeStatusModal}
      >
        <Modal.Header closeButton>
          <Modal.Title>{statusAction === "enable" ? "Enable User Account" : "Disable User Account"}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>
            Are you sure you want to {statusAction}{" "}
            <strong>{statusModalUser ? statusModalUser.userName : "this user"}</strong>?
          </p>
          {statusAction === "disable" && (
            <p className="user-access-modal-note">
              This will prevent the user from signing in until the account is enabled again.
            </p>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="outline-secondary" onClick={this.closeStatusModal}>
            Cancel
          </Button>
          <Button
            variant={statusAction === "enable" ? "success" : "danger"}
            onClick={this.confirmStatusToggle}
          >
            {statusAction === "enable" ? "Enable Account" : "Disable Account"}
          </Button>
        </Modal.Footer>
      </Modal>
      </React.Fragment>
    );
  }
}

export default UserTable;
